import { render } from "./TheMenuMobile.vue?vue&type=template&id=27c08204&scoped=true"
import script from "./TheMenuMobile.vue?vue&type=script&lang=js"
export * from "./TheMenuMobile.vue?vue&type=script&lang=js"

import "./TheMenuMobile.vue?vue&type=style&index=0&id=27c08204&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c08204"]])

export default __exports__